import firebase from "../firebase";
import UtilService from "@/services/UtilService";
const partners = firebase.ref("/partners");

class PartnerService {
  getAll(userInfo) {
    if(userInfo.Role === 'Partner Admin' || userInfo.Role === 'Partner Staff'){
      return partners.orderByChild("CreatedBy").equalTo(userInfo['Id']);
    } else {
      return partners.orderByChild("IsDeleted").equalTo(0);
    }
  }
  
  getById(Id) {
    var ref = partners.child('/'+Id);
    return ref;
  }

  create(partner) {
    return partners.orderByChild("Id").equalTo(partner["Id"]).once("value", snapshot => {
        if (snapshot.exists()){
          return null;
        } else {
            var newPostRef = partners.push();
            var Id = newPostRef.key;
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            partner['Id'] = Id;
            partner["CreatedDate"] = partner["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);

            return partners.child(Id).set(partner);
        }
    });
  }

  update(key, partner) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    partner["ModifiedDate"] = UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone);
    return partners.child(key).update(partner);
  }

  delete(key) { 
    return partners.child(key).update({ 
    IsDeleted: 1
   });
  }

  deleteAll() {
    return partners.remove();
  }

  
  getPartnerById(id){
    return partners.orderByKey().equalTo(id);
   }

  getPartnerByName(name){
    return partners.orderByChild("CompanyName").equalTo(name);
  }

  getPrimaryCode(code) {
    return partners.orderByChild("PrimaryCode").equalTo(code)
  }

  updatePrimaryCode(key,code,userid){
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    return partners.child(key).update({ 
      PrimaryCode: code,
      ModifiedDate: UtilService.convertUserTimeZoneToUTCWithSeconds(new Date(),userInfo.Timezone),
      ModifiedBy: userid
     });
  }

  checkIfCodeExists(code) {
    return partners
      .orderByChild("PrimaryCode")
      .equalTo(code)
      .once("value", snapshot => {
        if (snapshot.exists()) {
          return null;
        }
      });
  }
}

export default new PartnerService();
